<template>
  <div class="league-team-container">
    <el-form label-width="96px">
      <el-form-item label="选择联赛">
        <el-select v-model="match" filterable value-key="name" placeholder="请选择" @change="selectMatch" >
          <el-option
            v-for="item in matchList"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="选择组别">
        <el-select v-model="group" filterable value-key="name" placeholder="请选择" @change="selectGroup" >
          <el-option
            v-for="item in groupList"
            :key="item.id"
            :label="item.name"
            :value="item">
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="历史操作" >
        <el-button @click="getList" :disabled="!groupId">查询</el-button>
        <el-dropdown @command="routerTeamPlayer" >
          <span class="el-dropdown-link">
            球队操作历史<i class="el-icon-arrow-down el-icon--right"></i>
          </span>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item v-for="item in historyList" :key="item.id" :command="item.id" >{{ item.name }}</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </el-form-item>
      <!--<el-form-item>-->
        <!--<el-button @click="getList" :disabled="!groupId">查询</el-button>-->
      <!--</el-form-item>-->
    </el-form>
    <!-- list start -->
    <el-table
      v-loading="listLoading"
      :data="teamList"
      style="width: 100%">
      <el-table-column>
        <template slot="header" slot-scope="scope">
          <div>球队名称</div>
          <el-input
            v-model="search.name"
            @change="quickSearch"
            placeholder="搜索"/>
        </template>
        <template slot-scope="scope">
          <el-button type="text" @click="routerTeamPlayer(scope.row.id)">{{ scope.row.longName + '(' + scope.row.name + ')' }}</el-button>
        </template>
      </el-table-column>
      <el-table-column
        :formatter="formatAudit"
        v-if="allowTeamSignup"
        width="160"
        prop="auditStatus">
        <template slot="header" slot-scope="scope">
          <div>审核状态</div>
          <el-select v-model="search.auditStatus" @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in auditStateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="球员数量"
        align="center"
        width="120"
        prop="playerCount">
      </el-table-column>
      <el-table-column
        :formatter="formatState"
        width="120"
        prop="status">
        <template slot="header" slot-scope="scope">
          <div>状态</div>
          <el-select v-model="search.status" @change="quickSearch" placeholder="请选择">
            <el-option
              v-for="item in stateList"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </template>
      </el-table-column>
      <el-table-column
        label="操作"
        width="250"
        algin="right">
        <template slot-scope="scope">
          <el-button
            size="mini"
            @click="routerTeamPlayer(scope.row.id)">球员管理</el-button>
          <!--<el-button-->
          <!--size="mini"-->
          <!--@click="routerTeamPlayer(scope.row.id)">球员管理</el-button>-->
          <el-button
            size="mini"
            type="danger"
            @click="handleDelete(scope.$index, scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <div class="table-footer">
      <el-pagination
        v-show="totalCount>0"
        @size-change="handleSizeChange"
        :current-page="currentPage"
        :page-size="pageSize"
        :total="totalCount"
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange">
      </el-pagination>
    </div>
    <!-- list -->
  </div>
</template>

<script>
import find from 'lodash/find'
import { getMatchList, getMatchGroupList, getMatchGroupTeamList, auditStatus,
  createTeamStatus, matchStateList, updateTeam } from '@/api/match'
export default {
  name: 'TeamsList',
  data() {
    return {
      match: {},
      matchId: null,
      matchList: [],
      listLoading: false,
      group: {},
      groupId: null,
      groupList: [],
      teamList: [],
      search: {},
      totalCount: 0, // 默认数据总数
      pageSize: 20, // 每页的数据条数
      currentPage: 1, // 默认开始页面
      auditStateList: [],
      historyList: [],
      allowTeamSignup: 1
    }
  },
  created() {
    this.getMatchList()
    this.getAuditList()
    this.getHistoricalOperation()
  },
  computed: {
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val
      this.getList()
    },
    getMatchList() {
      const params = {
        status: 0,
        pageSize: 9999
      }
      getMatchList(params).then((resolve) => {
        this.matchList = resolve.data.list
      })
    },
    selectMatch(item) {
      this.group = {}
      getMatchGroupList({ matchId: item.id }).then((resolve) => {
        this.groupList = resolve.data.list
      })
      this.matchId = item.id
      this.groupId = ''
    },
    selectGroup(item) {
      this.groupId = item.id
      //this.getList()
    },
    getList(obj) {
      if (!this.groupId) return
      this.listLoading = true
      this.listQuery = {
        pageNum: this.currentPage,
        pageSize: this.pageSize,
        groupId: this.groupId
      }
      this.listQuery = Object.assign(this.listQuery, this.search)
      getMatchGroupTeamList(this.listQuery).then(response => {
        const data = response.data
        this.teamList = data.list
        this.currentPage = data.pageNum
        this.totalCount = data.count
        this.listLoading = false
      })
    },
    getAuditList() {
      this.stateList = matchStateList
      this.auditStateList = auditStatus
    },
    formatAudit: function(row, column) {
      const value = row[column.property]
      const obj = find(this.auditStateList, function(item) {
        return item.value === value
      })
      return obj && obj.label
    },
    formatState: function(row, column) {
      const value = row[column.property]
      const obj = find(this.stateList, function(item) {
        return item.value === value
      })
      return obj && obj.label
    },
    handleCurrentChange(val) {
      this.currentPage = val
      this.getList()
    },
    quickSearch() {
      this.getList()
    },
    routerTeamPlayer(id) {
      this.$router.push({
        name: 'LeagueGroupTeamPlayers',
        params: {
          id: this.matchId,
          gid: this.groupId,
          tid: id
        }
      })
    },
    deleteMatchTeam(userId) {
      const params = {
        groupId: this.groupId,
        teamId: userId,
        status: -2
      }
      updateTeam(params).then(response => {
        const data = response.data
        if (data) {
          this.$message({
            message: '删除成功',
            type: 'success',
            showClose: true,
            duration: 1000
          })
          this.getList()
        }
      })
    },
    handleDelete(index, row) {
      this.$confirm('此操作将永久删除该队伍, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true
      }).then(() => {
        this.deleteMatchTeam(row.id)
      }).catch(() => {
      })
    },
    getHistoricalOperation() {
      let params = {
        history: 1
      }
      getMatchGroupTeamList(params).then((resolve) => {
        const data = resolve.data
        this.historyList = data.list
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss">
  .league-team-container {
    margin: 30px 15px;
    .action-header {
      padding: 0 10px 10px 10px;
    }
    .el-table {
      th {
        div {
          line-height: 20px;
        }
        .el-select {
          padding-left: 0;
          padding-right: 0;
          .el-input {
            padding-left: 0;
            padding-right: 0;
          }
        }
      }
    }

    .table-footer {
      text-align: center;
      margin-top: 30px;
    }

    .el-date-editor.el-input {
      width: 140px;
    }

    .el-input__prefix {
      left: 10px
    }

    .el-input__suffix {
      right: 10px;
    }

    .el-input--prefix .el-input__inner {
      padding-left: 25px;
      padding-right: 20px;
    }

    .demonstration {
      display: block;
      padding-bottom: 15px;
    }

    .input-win {
      width: 200px !important;
    }

    .input-win .el-input__prefix {
      left: 5px;
    }

    .el-button--text {
      color: #606266
    }
    .el-button--text:hover {
      color: #409EFF;
      text-decoration: underline;
    }
    .el-button+.el-button {
      margin-left: 0;
    }

  }
</style>
